// extracted by mini-css-extract-plugin
export default {"modal":"vba-z","modalContent":"wba-z","footer":"xba-z","cancelBtn":"yba-z","disabled":"zba-z","formWrapper":"Aba-z","fade":"Bba-z","fade-in":"Cba-z","iframe":"Dba-z"};